/**
 * These functions make psuedo-random numbers.
 * The difference here is that they have a fixed seed
 * so they always return the same values given the same inputs.
 *
 * This is necessary for stable tests.
 */
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
export function generateNumbersInRangeWithDuplicates(min, max, count, seed) {
    var smallBatchSize = Math.floor(count / 3);
    var biggerList = generateNumbersInRange(min, max, count - smallBatchSize);
    var smallerList = randomiseList(biggerList, seed).slice(smallBatchSize);
    return randomiseList(__spreadArrays(smallerList, biggerList).sort(), seed);
}
export function generateNumbersInRange(min, max, count) {
    return count === 1
        ? [min]
        : Array.from({ length: count }, function (v, i) { return min + ((i % count) * (max - min)) / (count - 1); });
}
export function generateArrayWithValues(length, value) {
    return Array.from({ length: length }, function () { return value; });
}
export function generateIntegersInRange(min, max, count) {
    if (max - min + 1 < count) {
        throw new Error("Cannot generate " + count + " integers between " + min + " and " + max + ".");
    }
    return generateNumbersInRange(min, max, count).map(function (x) { return Math.floor(x); });
}
// tslint:disable:no-bitwise
/* eslint-disable no-bitwise */
/* Based on https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript */
function hashCode(s) {
    var hash = 0;
    for (var i = 0; i < s.length; i++) {
        hash = ((hash << 5) - hash + s.charCodeAt(i)) | 0;
    }
    return hash;
}
// tslint:enable:no-bitwise
/* eslint-enable no-bitwise */
// Based on code from https://stackoverflow.com/a/19303725
export function randomiseList(list, seed) {
    return list
        .map(function (value, index) {
        var x = Math.sin(index + 1 + hashCode(seed)) * 10000;
        return [value, x - Math.floor(x)];
    })
        .sort(function (_a, _b) {
        var a = _a[1];
        var b = _b[1];
        return b - a;
    })
        .map(function (_a) {
        var a = _a[0];
        return a;
    });
}
var ɵ0 = function () {
    var ids = __spreadArrays(randomiseList(generateIntegersInRange(1, 1000000, 10000), 'ids'));
    return function () {
        var id = ids.pop();
        if (id === undefined) {
            throw new Error('Ran out of ids, used more than 10,000.');
        }
        return id;
    };
};
export var generateId = (ɵ0)();
export function average(values) {
    if (values.length === 0) {
        return undefined;
    }
    return values.reduce(function (a, b) { return a + b; }, 0) / values.length;
}
export { ɵ0 };
